<!--elementId="activities" ver para que se usa-->
<card-info-detail-v2 class="content-detail" [showButton]="false">
  <h2 title class="name">
    Estacionamiento gratis si te hospedas en los hoteles Walt Disney World Resort
  </h2>
  <span expanded-info>
    <br />No incluye el servicio de estacionamiento asistido.<br />
  </span>
</card-info-detail-v2>
